export default "__VITE_ASSET__DNAcTfG4__"